
$( document ).ready(function() {  
  document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      container: '#Huratips-Loop',
      pagination: '#Huratips-Pagination'
    });
  });
  // $('#AddToCart--product-template').click(function(){
  //   $('#xrs-bundle').trigger('click');
  //   $('body').addClass('itg_hide_header');
  // });
  $("#search_input").keyup(function(){
  var search_val = $('#search_input').val();
    var len = $( ".search_article a:contains("+search_val+")" ).length; 
     $('.search_article a').hide();
     $('.search_error').hide();
 //  alert(search_val)
    if(search_val != ''){
     if(len >= 1){
        $('.search_article').show();
        var article_val  = $( ".search_article a:contains("+search_val+")" ).show();
       $('.search_error').hide();
     }else{
       $('.search_error').html("result not found for "+ search_val).show();
        $('.search_article').hide();
     }
    }
   });
});

$(document).ready(function(){
  if($(window).width() < 767)
    {
    $('.itg_collections').addClass('productgrid-listview');
    $('.itg_collections').removeClass('productgrid-gridview');
    $('.utils-viewtoggle-button[data-collection-view="list-view"]').addClass('active');
    $('.utils-viewtoggle-button[data-collection-view="grid-view"]').removeClass('active');
    }
});
